import type { ReactNode } from 'react';
import Heading from '../Heading/Heading';

type CardProps = {
  iconURL: string;
  headingContent?: ReactNode;
  body?: ReactNode;
};

function IconCard({
  iconURL,
  headingContent='',
  body='',
}: CardProps) {
  return (
    <div className='work-list-item grid grid-cols-[auto_1fr] p-2 rounded-lg border border-gray-300 mb-4 bg-white'>
      <div className='work-icon p-2'>
        <div className='icon-wrapper rounded-full bg-[#FBFAF9] p-2'>
          <img src={iconURL} alt='' className='img-fluid' />
        </div>
      </div>
      <div className='work-list-item-desc p-2'>
        <Heading
          level={3}
          classes='title text-sm mb-2'
          gutterClass=' mb-2'
          align='left'
        >
          {headingContent}
        </Heading>
        <div className='desc text-sm text-left'>
          {body}
        </div>
      </div>
    </div>
  );
}

export default IconCard;
